const techs = {
  ts: "TypeScript",
  js: "JavaScript",
  python: "Python",
  php: "PHP",
  sqlite: "SQLite",
  mongo: "MongoDB",
  postgreSql: "PostgreSQL",
  supabase: "Supabase",
  html: "HTML",
  css: "CSS",
  sass: "SASS",
  scss: "SCSS",
  tailwind: "Tailwind CSS",
  liquid: "Liquid",
  redis: "Redis",
  docker: "Docker",
  aws: "AWS",
  netlify: "Netlify",
  vercel: "Vercel",
  node: "Node.js",
  vscode: "VSCode",
  figma: "Figma",
  git: "Git & GitHub",
  postman: "Postman",
  n8n: "n8n",
  react: "React",
  next: "Next.js",
  vue: "Vue.js",
  express: "Express",
  fastapi: "FastAPI",
  streamlit: "Streamlit",
  wordpress: "WordPress",
  shopify: "Shopify",
  woocommerce: "WooCommerce",
  webflow: "Webflow",
  prisma: "Prisma",
  drizzle: "Drizzle ORM",
  webpack: "WebPack",
  openai: "OpenAI API",
  anthropic: "Anthropic API",
  gemini: "Gemini API",
  openrouter: "OpenRouter",
  huggingface: "Hugging Face",
  ollama: "Ollama",
};

export default techs;
